import { useEffect } from 'react';

import { scrollToTop } from '../../../common/utils/utilFunctions';

import EntityLandingPageLayout from './EntityLandingPage/EntityLandingPageLayout';

const EntityDetailLayout = () => {
	useEffect(() => {
		scrollToTop();
	}, []);

	return <EntityLandingPageLayout />;
};

export default EntityDetailLayout;
